export const prepareModule = (module: any) => {
  const lessons = module.lessons.map((lesson: any) => ({
    ...lesson,
    available: true,
    completed: false,
  }));

  return {
    ...module,
    available: true,
    completed: false,
    progress: 0,
    lessons,
  };
};
